export enum BatchSearchPeriodTypes {
    ActiveInPeriod = 'activeInPeriod',
    EndsInPeriod = 'endsInPeriod',
    StartsInPeriod = 'startsInPeriod',
}
